/* @flow */

import stateColorsStatusIugu from './state-colors-status-iugu';
import traduzirStatusIugu from './traduzir-status-iugu';

const badgeEtapa = status => `
    <span class="m-badge m-badge--${stateColorsStatusIugu(status)} m-badge--wide">
        ${traduzirStatusIugu(status)}
    </span>
`;

export default badgeEtapa;
